import {ngAsync} from 'shared/utils/ng-@decorators';
import {responseToData, transferify, unRestangularize} from 'shared/utils/data-service-utils';
import type {ActionResponse, ConfirmableRequest, RecordExport} from 'typings/portaro.be.types';

export class RecordExportDataService {
    public static serviceName = 'recordExportDataService';

    public static readonly ROUTE = 'record-exports';

    /*@ngInject*/
    constructor(private Restangular: Restangular.IService) {
    }

    @ngAsync()
    @unRestangularize()
    public async getAll(): Promise<RecordExport[]> {
        try {
            return this.Restangular
                .all(RecordExportDataService.ROUTE)
                .getList();
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }

    @ngAsync()
    @unRestangularize()
    public async create(recordExportRequest: RecordExport | ConfirmableRequest): Promise<ActionResponse> {
        try {
            return await this.Restangular
                .all(RecordExportDataService.ROUTE)
                .post(transferify(recordExportRequest))
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }

    @ngAsync()
    @unRestangularize()
    public async edit(recordExportRequest: RecordExport): Promise<ActionResponse> {
        try {
            return await this.Restangular
                .one(RecordExportDataService.ROUTE)
                .post('edit', transferify({...recordExportRequest, confirmed: false}))
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }
}